import TimeAndSaleProxy from '../../../proxies/prices/TimeAndSaleProxy';
import ServiceBase from '../../ServiceBase';

class TimeAndSaleService extends ServiceBase {
  getTimeAndSale(params) {
    return this.applyMemoryCache('TimeAndSaleService.getTimeAndSale', params)(
      () => TimeAndSaleProxy.getTimeAndSale(params),
    );
  }

  exportTable(params) {
    return this.applyMemoryCache('TimeAndSaleService.exportTable', params)(() =>
      TimeAndSaleProxy.exportTable(params),
    );
  }

  getBuSdChart(params) {
    return this.applyMemoryCache(
      'TimeAndSaleService.GetTimeAndSalesBuSdChart',
      params,
    )(() => TimeAndSaleProxy.getBuSdChart(params));
  }

  getStatChartData(params) {
    return this.applyMemoryCache(
      'TimeAndSaleService.GetTimeAndSalesStatChart',
      params,
    )(() => TimeAndSaleProxy.getStatChartData(params));
  }
}

const timeAndSaleService = new TimeAndSaleService();
export default timeAndSaleService;
